const commandAgentStates = {
    connect: {
        id: 1,
        code: "connect",
        label: "Connecté",
        display: true,
    },
    disconnect: {
        id: 2,
        code: "disconnect",
        label: "Déconnecté",
        display: false,
    },
    personnal_pause: {
        id: 3,
        code: "personnal_pause",
        label: "Pause personnelle",
        display: true,
    },
    4: {
        id: 4,
        code: "end_personnal_pause",
        label: "Fin de pause personnelle",
        display: false,
    },
    administrative_pause: {
        id: 5,
        code: "administrative_pause",
        label: "Pause administrative",
        display: true,
    },
    6: {
        id: 6,
        code: "end_administrative_pause",
        label: "Fin de pause administrative",
        display: false,
    },
};

export default commandAgentStates;
